import React, { memo } from 'react'
import { Box, Typography, Button } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { useNavigate } from 'react-router-dom'

const NotFound = ({
  title = 'Objet introuvable',
  message = "L'objet demandé est inexistant ou a été supprimé.",
  showBackButton = true,
  onBackClick
}) => {
  const navigate = useNavigate()

  const handleBack = () => {
    onBackClick?.() ?? navigate(-1)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 65px)',
        overflowY: 'auto',
        flex: '1 1 auto'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '80vh',
          textAlign: 'center',
          px: 2
        }}
      >
        <ErrorOutlineIcon color='error' sx={{ fontSize: 80, mb: 2 }} />
        <Typography variant='h5' gutterBottom>
          {title}
        </Typography>
        <Typography variant='body1' color='text.secondary' mb={3}>
          {message}
        </Typography>
        {showBackButton && (
          <Button variant='contained' color='primary' onClick={handleBack}>
            Retour
          </Button>
        )}
      </Box>
    </Box>
  )
}

export default memo(NotFound)
